<template>
  <div class="media" ref="media">

      <Burger navType="Media" />
      <MediaMenu @clickedNavId="loadMedia" />

      <div class="mplayer">
            <div class="mediatitle">{{this.mediatitle}}</div>
            <video-player v-show="showVideoPlayer" id="MediaPlayer" ref="player" :options="videoOptions"/>
          
            <audio id="audioplayer" controls  ref="audioplayer" v-show="showAudioPlayer" >
              <source v-bind:src="this.audioOptions.source" type="audio/mpeg"  />
              <!--<source :src="`${this.audioOptions.source}`" type="audio/mpeg">-->
              Ihr Browser unterstützt keine Audio-Wiedergabe...
            </audio>

            <div class="legend">{{this.medialegend}}</div>
      </div>      

  </div>
</template>


<script>
import MediaMenu from '@/components/MediaMenu.vue'
import Burger from '@/components/Burger.vue'
import VideoPlayer from "@/components/VideoPlayer.vue"

export default {
  name: 'media',
  components: {
    MediaMenu,
    VideoPlayer,
    Burger    
  } ,
  data: function() {
      return { 
        showVideoPlayer: false,
        showAudioPlayer: false,
        audioOptions: {
          source: "",
          legend: ""
        },
        medialegend: "",
        mediatitle: "",
        videoOptions: {
          autoplay: false,          
          controls: false /*,          
          sources: [
            {
              src:
                "",
                type: "video/mp4"
            }
          ]*/
        }
      }
  },

  methods: {
    loadMediaFromRouter(id){
    
      let media = {}
      const tmpvid = _.find(this.$store.state.mediaToc[0].level1, ['id', id]) 
      const tmpaud = _.find(this.$store.state.mediaToc[1].level1, ['id', id])
      if (typeof tmpvid !== 'undefined') {
        media = tmpvid
      }
      if (typeof tmpaud !== 'undefined'){
        media = tmpaud
      }

    },
    loadMedia: function(value){ 

      let mItem = this.$store.state.mediaItem
      let url = "/video/"
      if (location.hostname === "localhost" || location.hostname === "127.0.0.1"){
        //url = "//fd.ch.saphir.ch-meta.net/scans/"
        url = "//fd.ch.saphir.ch-meta.net/video/"
      }      
      

      if(mItem.type ==='video') {

      // this.videoOptions.sources.src = url + this.$store.state.mediaItem.href
        this.$refs.player.$refs.videoPlayer.src = url + this.$store.state.mediaItem.href
        this.$refs.player.$refs.videoPlayer.type = "video/mp4"
        this.$refs.player.$refs.videoPlayer.controls = true

      // this.$refs.player.$refs.videoPlayer.sources =[{ type: "video/mp4", src: url + this.$store.state.mediaItem.href }]
        this.showVideoPlayer = true
        this.showAudioPlayer = false

        this.$refs.audioplayer.pause()
        this.$refs.player.$refs.videoPlayer.play()
      } else {

        url = "/audio/"
        if (location.hostname === "localhost" || location.hostname === "127.0.0.1"){
          //url = "//fd.ch.saphir.ch-meta.net/scans/"
          url = "//fd.ch.saphir.ch-meta.net/audio/"
        }

        this.showAudioPlayer = true
        this.showVideoPlayer = false
        this.$refs.player.$refs.videoPlayer.pause()
        this.$refs.audioplayer.load()
        this.$refs.audioplayer.play()
        
        this.audioOptions.source = url + this.$store.state.mediaItem.href
        this.audioOptions.legend = this.$store.state.mediaItem.text
      }
      this.medialegend =  this.$store.state.mediaItem.text 
      this.mediatitle =  this.$store.state.mediaItem.title 
    }
  },
    watch: {     
    $route(to, from) { 
      if (to.name.includes("media") ){
        
        this.$nextTick(() => {  
          var media = {}
          const tmpvid = _.find(this.$store.state.mediaToc[0].level1, ['id', to.params.id]) 
          const tmpaud = _.find(this.$store.state.mediaToc[1].level1, ['id', to.params.id])
          if (typeof tmpvid !== 'undefined') {
            media = tmpvid
          }
          if (typeof tmpaud !== 'undefined'){
            media = tmpaud
          }
          this.$store.commit('updateMediaItem',media)
          this.loadMedia()          
        })
      }      
    },
    deep: true,
    immediate:true      
  },

  mounted() {

    if (JSON.stringify(this.$store.state.mediaToc) === '{}' ) {  
      
      this.$http.get("/json/tocMedia.json")
      .then(              
        response => {
          //this.level0 = response.data.level0
          this.$store.commit('setMediaToc',response.data.level0)

          //this.$store.state.mediaId is set in  router.beforeEach()
          let media = {}
          const tmpvid = _.find(this.$store.state.mediaToc[0].level1, ['id', this.$store.state.mediaId]) 
          const tmpaud = _.find(this.$store.state.mediaToc[1].level1, ['id', this.$store.state.mediaId])
          if (typeof tmpvid !== 'undefined') {
            media = tmpvid
          }
          if (typeof tmpaud !== 'undefined'){
            media = tmpaud
          }

          this.$store.commit('updateMediaItem',media)
          this.loadMedia()         
          
          }
        )
    }   

    this.$refs.player.$refs.videoPlayer.setAttribute("controlsList","nodownload")
          
  },  

  updated () {
   // alert ("updated")
  } 

}


</script>

<style lang="scss">
@import '~video.js/dist/video-js.css';

.media {
  .mplayer {
    margin: 100px auto;
    border: 1px gray solid;
    padding: 2rem;
  }
  .mediatitle {
    font-size: 2rem;
    padding: 0 0 1rem;
    max-width: 700px;
    text-align: left;
    line-height: 2.2rem;
  }
}



</style>
